import React from "react";
import logo from "../../img/logo.svg";
import "./style.scss";
import { simplyClick } from "../../helpers";
import { landingId } from "../../constants";

const Header = ({ step }) => {
  const handleLoginClick = () => {
    const eventMap = {
      0: "cl_lnd_cd5_look_for_sign",
      1: "cl_lnd_cd5_welcome_sign",
      2: "cl_lnd_cd5_i_am_sign",
      3: "cl_lnd_cd5_first_ques_sign",
      4: "cl_lnd_cd5_sec_ques_sign",
      5: "cl_lnd_cd5_third_ques_sign",
      6: "cl_lnd_cd5_analyzing_sign",
      7: "cl_lnd_cd5_great_job_sign",
      8: "cl_lnd_cd5_fourth_ques_sign",
      9: "cl_lnd_cd5_fifth_ques_sign",
      10: "cl_lnd_cd5_sixth_ques_sign",
      11: "cl_lnd_cd5_refining_sign",
      12: "cl_lnd_cd5_great_job_2_sign",
      13: "cl_lnd_cd5_sev_ques_sign",
      14: "cl_lnd_cd5_most_men_sign",
      15: "cl_lnd_cd5_thank_you_sign",
      16: "cl_lnd_cd5_name_sign",
      17: "cl_lnd_cd5_date_birth_sign",
      18: "cl_lnd_cd5_email_sign",
      19: "cl_lnd_cd5_password_sign",
    };

    const eventName = eventMap[step] || "";
    simplyClick(eventName);
  };

  return (
    <div className={"header"}>
      <img src={logo} alt="logo" />
      <a href="/login/" className={"btn btn--sign"} onClick={handleLoginClick}>
        Sign in
      </a>
    </div>
  );
};

export default Header;
